// extracted by mini-css-extract-plugin
export default {"delaySkeletonLoad":"issue-timeline-loading-module__delaySkeletonLoad--qiw2o","showAfterDelay":"issue-timeline-loading-module__showAfterDelay--aE_Bb"};